const LOAD_MLSTN_SAGA = 'app/milestoneActivity/LOAD_MLSTN_SAGA';
const LOAD_MLSTN_RESULT = 'app/milestoneActivity/LOAD_MLSTN_RESULT';


const GET_TASKS_SAGA = 'app/milestoneActivity/GET_TASKS_SAGA';
const GET_TASKS_RESULT = 'app/milestoneActivity/GET_TASKS_RESULT';

const GET_STATUS_SAGA = 'app/milestoneActivity/GET_STATUS_SAGA';
const GET_STATUS_RESULT = 'app/milestoneActivity/GET_STATUS_RESULT';
const CLEAR_TASK_SAGA = 'app/milestoneActivity/CLEAR_TASK_SAGA';
const SHOW_LOADER = 'app/milestoneActivity/SHOW_LOADER';
const HIDE_LOADER = 'app/milestoneActivity/HIDE_LOADER';
const SHOW_LOADER_TASK = 'app/milestoneActivity/SHOW_LOADER_TASK';
const HIDE_LOADER_TASK = 'app/milestoneActivity/HIDE_LOADER_TASK';

const GET_TASKS_DETAILS = 'app/milestoneActivity/GET_TASKS_DETAILS';
const STORE_TASKS_DETAILS = 'app/milestoneActivity/STORE_TASKS_DETAILS';
const STORE_MLSTN_NAME = 'app/milestoneActivity/STORE_MLSTN_NAME';
const GET_STAGER_TASKS = 'app/milestoneActivity/GET_STAGER_TASKS';
const STORE_STAGER_TASKS = 'app/milestoneActivity/STORE_STAGER_TASKS';

const CLEAR_MLSTN_DATA = 'app/milestoneActivity/CLEAR_MLSTN_DATA';

const GO_BACK_TO_SEARCH = 'app/milestoneActivity/GO_BACK_TO_SEARCH';


export {
  SHOW_LOADER,
  HIDE_LOADER,
  SHOW_LOADER_TASK,
  HIDE_LOADER_TASK,
  LOAD_MLSTN_SAGA,
  LOAD_MLSTN_RESULT,
  GET_TASKS_SAGA,
  GET_TASKS_RESULT,
  GET_STATUS_SAGA,
  GET_STATUS_RESULT,
  CLEAR_TASK_SAGA,
  GET_TASKS_DETAILS,
  STORE_TASKS_DETAILS,
  STORE_MLSTN_NAME,
  GET_STAGER_TASKS,
  STORE_STAGER_TASKS,
  CLEAR_MLSTN_DATA,
  GO_BACK_TO_SEARCH,
};
